<template>
  <div>
    <!-- Select view modal -->
    <wg-modal v-if="showViewDialog" @closeModal="showViewDialog = false">
      <div
        class="wg-row"
        slot="header"
        style="flex-wrap: nowrap; align-items: center"
      >
        <div class="com-anm22-app-text-xl" slot="header">
          {{ $anm22.strLang(lang, "View", "Visualizzazione") }}
        </div>
      </div>
      <div slot="body" class="views-list">
        <div
          v-for="(v, index) in viewsList"
          :key="'view-btn-' + index"
          :class="['item', selectedView == v.id ? 'selected' : '']"
          @click="changeView(v.id)"
        >
          <img :src="v.icon" />
          <div>{{ v.label }}</div>
        </div>
      </div>
    </wg-modal>
    <!-- New event modal -->
    <!-- <wg-modal v-if="showNewEventDialog" :width="'400px'" @closeModal="showNewEventDialog=!showNewEventDialog">
      <div class="wg-row" style="justify-content:space-around;" slot="body">
        <div 
            class="display-flex div-icon-label"
            @click="newEvent(1)">
          <img 
              :src="$anm22.icons.getWorldIcon('event')"
              class="com-anm22-app-img-fixed-height-l"
          >
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, 'Event', 'Evento') }}
          </div>
        </div>
        <div 
            class="display-flex div-icon-label" 
            @click="newEvent(5)">
          <img 
              :src="$anm22.icons.getWorldIcon('reminder')"
              class="com-anm22-app-img-fixed-height-l"
          >
          <div class="vertical-height-div" style="height:10px;"></div>
          <div class="com-anm22-app-text-l">
            {{ $anm22.strLang(lang, 'Reminder', 'Promemoria') }}
          </div>
        </div>
      </div>
    </wg-modal>-->
    <!--  -->
    <wg-modal
      :width="windowWidth > 700 ? '500px' : '80%'"
      v-if="showSearchDialog"
      :portal="true"
      @closeModal="closeSearch"
    >
      <div slot="header">
        <span class="font">{{
          $anm22.strLang(lang, "Search avaiability", "Ricerca disponibilità")
        }}</span>
      </div>
      <filter-view slot="body"></filter-view>
    </wg-modal>
    <wg-modal
      :width="windowWidth > 700 ? '500px' : '80%'"
      v-if="showWorksDialog"
      :portal="true"
      @closeModal="closeWorks"
    >
      <div slot="header">
        <span class="font">{{
          $anm22.strLang(lang, "Select Work", "Seleziona Azienda")
        }}</span>
      </div>
      <work-select slot="body" :workSelected="workSelected"></work-select>
    </wg-modal>
    <div v-if="loadEvent">
      <wg-modal
        :width="'100px'"
        :simple="true"
        v-if="showEventDialog"
        :portal="true"
      >
        <div
          class="wg-row"
          style="align-items: center; justify-content: center"
          slot="body"
        >
          <vue-simple-spinner
            size="medium"
            line-fg-color="rgb(255, 0, 0)"
          ></vue-simple-spinner>
        </div>
      </wg-modal>
    </div>
    <div v-else>
      <wg-modal
        :width="windowWidth > 800 ? '500px' : '80%'"
        v-if="showEventDialog"
        :portal="true"
        @closeModal="closeEvent"
      >
        <div slot="header">
          <!-- <div v-if="!loadEvent">         
          <wg-spinner-modal line-fg-color="rgb(136, 237, 124)"></wg-spinner-modal>
          </div>-->
          <div v-if="!loadEvent">
            <!-- <div class="vertical-height-div" style="height:20px;"></div> -->
            <span class="font">
              {{
                selectedEvent.idWorldEvent
                  ? $anm22.strLang(lang, "Edit", "Modifica")
                  : $anm22.strLang(lang, "New", "Nuovo")
              }}
            </span>
          </div>
        </div>
        <div slot="body" class="wg-row">
          <event-detail
            @showEvent="showEvent"
            :eventRef="selectedEvent"
            :currentWork="workSelected"
          ></event-detail>
        </div>
      </wg-modal>
    </div>
    <div
      v-if="filterUsers.length > 0"
      style="
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
        cursor: pointer;
        background-color:#ffbf00;
        opacity:0.8;
      "
    >
      <div
        v-for="(filter, index) in filterUsers"
        :key="'filter-' + index"
        class="display-flex filter-button"
        @click="removeFilterUser(index)"
      >
        <img
          class="com-anm22-app-img-fixed-height-s"
          :src="$anm22.icons.getWorldIcon('deleteBlack')"
          style="margin-right: 10px; height: 10px"
        />
        <div class="com-anm22-app-text-s">{{ filter.name }}</div>
      </div>
    </div>
    <div
      v-if="filters.length > 0"
      style="
        display: flex;
        flex-wrap: nowrap;
        justify-content: center;
        align-items: center;
        cursor: pointer;
      "
    >
      <div
        v-for="(filter, index) in filters"
        :key="'filter-' + index"
        class="display-flex filter-button"
        @click="removeFilter(index)"
      >
        <img
          class="com-anm22-app-img-fixed-height-s"
          :src="$anm22.icons.getWorldIcon('deleteBlack')"
          style="margin-right: 10px; height: 10px"
        />
        <div class="com-anm22-app-text-s">{{ filter.name }}</div>
      </div>
    </div>
    <component
      :events="events"
      :now="now"
      :selectedTimezone="selectedTimezone"
      :loading="loading"
      :loadEvent="loadEvent"
      :is="selectedView"
      :box="closeWork"
      :currentTime="currentTime"
      :currentW="workSelected"
      :getMyEvents="getMyEvents"
      :getWorkEvents="getWorkEvents"
      @changeView="openChangeViewDialog"
      @showWorks="showWorks"
      @newEvent="newEvent"
      @selectEvent="showEvent"
      @searchEvent="showSearch"
      @close="closeChangeWork"
    ></component>
    <!-- Floating button per l'aggiunta -->
    <template v-if="openSelectButton">
      <wg-fab
        class="sub-add-button event"
        :icon="$anm22.icons.getWorldIcon('menuCalendarRed')"
        :dimension="{ width: '35px', height: '35px' }"
        :imgDimension="{ width: '20px', height: '20px' }"
        :click="newEvent"
        :title="$anm22.strLang(lang, 'New Event', 'Nuovo Evento')"
        :bgColor="'white'"
      ></wg-fab>
      <wg-fab
        class="sub-add-button project"
        :icon="$anm22.icons.getWorldIcon('menuTasksGreen')"
        :dimension="{ width: '35px', height: '35px' }"
        :imgDimension="{ width: '20px', height: '20px' }"
        :click="newProjectModal"
        :title="$anm22.strLang(lang, 'New project', 'Nuovo progetto')"
        :bgColor="'white'"
      ></wg-fab>
    </template>
    <wg-fab
      style="position: fixed; bottom: 30px; right: 30px"
      :icon="$anm22.icons.getWorldIcon('addWhite')"
      :click="checkLicense && canAdd ? changeAddStatus : newEvent"
      :title="$anm22.strLang(lang, 'New Event', 'Nuovo Evento')"
      :bgColor="'red'"
    ></wg-fab>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Spinner from "vue-simple-spinner";
import HeadBar from "../components/HeadBar.vue";
import MonthView from "../components/MonthView.vue";
import WeeklyView from "../components/WeeklyView.vue";
import LastEventView from "../components/LastEventView.vue";
import TicketsView from "./TicketsView.vue";
import EventView from "../components/EventView.vue";
import FilterView from "../components/FilterView.vue";
import WorkSelect from "../components/WorkSelect.vue";
import EventDetail from "../components/events/EventDetail.vue";

export default {
  data() {
    return {
      block: true,
      loading: false,
      loadEvent: false,
      selectedTimezone: this.$moment.tz.guess(),
      openSelectButton: false,
      selectedView:
        this.$anm22.getCookie("com_anm22_calendar_view") !== ""
          ? this.cookies(this.$anm22.getCookie("com_anm22_calendar_view"))
          : "MonthView",
      selectedEvent: null,
      now: this.$moment(),
      showEventDialog: false,
      showSearchDialog: false,
      showWorksDialog: false,
      currentTime: this.$moment().unix(),
      filters: [],
      filterUsers: [],
      workSelected: this.$store.getters["getWorkSelected"],
      closeWork:
        this.$anm22.getCookie("close") !== ""
          ? this.$anm22.getCookie("close")
          : false,
      showViewDialog: false,
      // new event dialog
      // showNewEventDialog: false,
      // tempCreationDate: null
    };
  },
  computed: {
    ...mapState({
      windowWidth: (state) => state.windowWidth,
      user: (state) => state.auth.user,
      lang: (state) => state.lang,
    }),
    licenses() {
      if (this.workSelected !== "my") {
        return [this.$store.getters["licenses/getByWork"](this.workSelected)];
      } else {
        return [];
      }
    },
    canAdd() {
      const functions = this.licenses.filter(
        (l) =>
          l &&
          l.config.tasks &&
          l.config.tasks.project &&
          l.config.tasks.project["add-rules"]
      );
      if (functions.length > 0) {
        return functions.reduce(
          (result, l) =>
            result && this.$anm22[l.config.tasks.project["add-rules"]](this),
          true
        );
      } else {
        return this.userPermission <= 3 || this.customerManager;
      }
    },
    userPermission() {
      return this.$store.getters["employments/getPermByWork"](
        this.workSelected
      );
    },
    customerManager() {
      if (this.workSelected !== "my") {
        const e = this.$store.getters["employments/get"](
          this.user.idWorldUser + "-" + this.workSelected
        );
        if (e && e.clients.reduce((res, c) => res || c.isManager, false)) {
          return true;
        }
      }
      return false;
    },
    checkLicense() {
      if (this.licenses.length > 0) {
        const license = this.licenses[0];
        if (
          license &&
          license.config.apps &&
          license.config.apps.tasks &&
          license.config.apps.tasks.enabled == true
        ) {
          return true;
        }
        return false;
      } else {
        return false;
      }
    },
    users() {
      return this.$store.getters["users/getAll"];
    },
    events() {
      if (this.workSelected == "my") {
        return this.$store.getters["events/getMyEvents"](
          this.user.idWorldUser
        ).filter(
          (c) =>
            this.checkUserAvaiability(c) &&
            this.filters.reduce((result, filter) => {
              return result && filter.fn(c);
            }, true)
        );
      } else {
        return this.$store.getters["events/getAllByWork"](
          this.workSelected
        ).filter(
          (c) =>
            this.checkUserAvaiability(c) &&
            this.filters.reduce((result, filter) => {
              return result && filter.fn(c);
            }, true)
        );
      }
    },
    viewsList() {
      var views = [
        {
          id: "MonthView",
          icon: this.$anm22.icons.getWorldIcon("viewLastEvents"),
          label: this.$anm22.strLang(this.lang, "Month", "Mese"),
        },
        {
          id: "WeeklyView",
          icon: this.$anm22.icons.getWorldIcon("viewCols"),
          label: this.$anm22.strLang(this.lang, "Settimana", "Week"),
        },
        {
          id: "LastEventView",
          icon: this.$anm22.icons.getWorldIcon("viewFull"),
          label: this.$anm22.strLang(this.lang, "List", "Lista"),
        },
      ];
      if (this.workSelected == 4432) {
        views.push({
          id: "TicketsView",
          icon: this.$anm22.icons.getWorldIcon("ticket"),
          label: this.$anm22.strLang(this.lang, "Tickets", "Tickets"),
        });
      }
      return views;
    },
  },
  created() {
    if (this.workSelected != "my") {
      this.loading = true;
      this.getWorkEvents();
    } else {
      this.loading = true;
      this.$http
        .get("events?currentTime=" + this.currentTime)
        .then((response) => {
          {
            return Promise.all([
              this.$store.dispatch("events/update", {
                vlf: this.$vlf("events"),
                objs: response.data.events,
                cleanFilters: [(e) => e.type == 4 || e.type == 8],
                saveFilters: [
                  (e) => e.endTimestamp > this.currentTime - 86400 * 31,
                ],
              }),
              this.$store.dispatch("places/update", {
                vlf: this.$vlf("places"),
                objs: response.data.places,
              }),
              this.$store.dispatch("employments/update", {
                vlf: this.$vlf("employments"),
                objs: response.data.employments,
                cleanFilters: [],
              }),
              this.$store.dispatch("users/update", {
                vlf: this.$vlf("users"),
                objs: response.data.users,
                cleanFilters: [],
              }),
              this.$store.dispatch("invites/update", {
                vlf: this.$vlf("invites"),
                objs: response.data.invites,
                cleanFilters: [],
              }),
              this.$store.dispatch("works/update", {
                vlf: this.$vlf("works"),
                objs: response.data.works,
                cleanFilters: [],
              }),
            ]);
          }
        })
        .then((response) => {
          if (this.$route.params.id) {
            let slugs = this.$route.params.id;
            let slug = slugs.split(",");
            let idWorldEvent = slug[0];
            let idWorldEventInvite = slug[1];
            let status = slug[2];
            if (status) {
              this.updateStatus(idWorldEventInvite, status);
            }
            let el = this.$store.getters["events/get"](idWorldEvent);
            this.showEvent(el);
          }
          this.$Progress.finish();
          this.block = false;
          this.loading = false;
        })
        .catch((error) => console.log(error));
    }
  },
  methods: {
    selectWork(work) {
      this.openSelectButton = false;
      //controllo se la pagina ha caricato
      if (this.block == false) {
        this.$store.dispatch("setWorkSelected", Number(work));
        this.$anm22.setCookie("anm22_work", work, 31536000);
        this.workSelected = work;
        if (work != "my") {
          this.loadEvent = true;
          this.getWorkEvents();
        } else {
          this.loadEvent = true;
          this.getMyEvents();
        }
      }
    },
    checkUserAvaiability(event) {
      let invites = this.$store.getters["invites/getByEvent"](
        event.idWorldEvent
      );
      let invited = false;
      // Controllo che ci siano utenti da cercare
      if (this.filterUsers.length > 0) {
        //Proseguo solo se l'evento non è un reminder
        if (event.type != 5) {
          this.filterUsers.forEach((filter) => {
            //Se negli inviti è presente uno di questi utenti ed è in attesa,in forse o parteciperà,allora è un evento che devo mostrare
            invites.forEach((invite) => {
              if (invite.user == filter.id && invite.status != 2) {
                invited = true;
              }
            });
          });
          return invited;
        } else {
          return false;
        }
      } else {
        return true;
      }
    },
    cookies(cookie) {
      switch (cookie) {
        case "month":
          return "MonthView";
          break;
        case "week":
          return "WeeklyView";
          break;
        case "line":
          return "LastEventView";
      }
    },
    newProjectModal() {
      window.location.href = "https://tasks.anm22.it/?addProject=1";
    },
    changeAddStatus() {
      this.openSelectButton = !this.openSelectButton;
    },
    updateData() {
      if (!this.$store.getters["offline/isOffline"]) {
        this.$http
          .get("events?currentTime=" + this.currentTime)
          .then((response) => {
            return Promise.all([
              this.$store.dispatch("events/update", {
                vlf: this.$vlf("events"),
                objs: response.data.events,
                cleanFilters: [(e) => e.type == 4 || e.type == 8],
                saveFilters: [
                  (e) => e.endTimestamp > this.currentTime - 86400 * 31,
                ],
              }),
              this.$store.dispatch("invites/update", {
                vlf: this.$vlf("invites"),
                objs: response.data.invites,
                cleanFilters: [],
              }),
            ]);
          })
          .then((response) => {
            this.block = false;
            this.loading = false;
          })
          .catch((error) => console.log(error));
      }
    },
    updateWorkData() {
      if (!this.$store.getters["offline/isOffline"]) {
        this.$http
          .get(
            "events/getworkevents?idWork=" +
              this.workSelected +
              "&currentTime=" +
              this.currentTime
          )
          .then((response) => {
            return Promise.all([
              this.$store.dispatch("events/update", {
                vlf: this.$vlf("events"),
                objs: response.data.events,
                cleanFilters: [(e) => e.type == 4 || e.type == 8],
                saveFilters: [
                  (e) => e.endTimestamp > this.currentTime - 86400 * 31,
                ],
              }),
              this.$store.dispatch("invites/update", {
                vlf: this.$vlf("invites"),
                objs: response.data.invites,
                cleanFilters: [],
              }),
            ]);
          })
          .then((response) => {
            this.loading = false;
            this.block = false;
          })
          .catch((error) => console.log(error));
      }
    },
    //recupero gli eventi per work
    getWorkEvents() {
      this.$http
        .get(
          "events/getworkevents?idWork=" +
            this.workSelected +
            "&currentTime=" +
            this.currentTime
        )
        .then((response) => {
          return Promise.all([
            this.$store.dispatch("events/update", {
              vlf: this.$vlf("events"),
              objs: response.data.events,
              cleanFilters: [(e) => e.type == 4 || e.type == 8],
              saveFilters: [
                (e) => e.endTimestamp > this.currentTime - 86400 * 31,
              ],
            }),
            this.$store.dispatch("employments/update", {
              vlf: this.$vlf("employments"),
              objs: response.data.employments,
            }),
            this.$store.dispatch("users/update", {
              vlf: this.$vlf("users"),
              objs: response.data.users,
              cleanFilters: [],
            }),
            this.$store.dispatch("invites/update", {
              vlf: this.$vlf("invites"),
              objs: response.data.invites,
              cleanFilters: [],
            }),
            this.$store.dispatch("works/update", {
              vlf: this.$vlf("works"),
              objs: response.data.works,
              cleanFilters: [],
            }),
            this.$store.dispatch("licenses/update", {
              vlf: this.$vlf("licenses"),
              objs: response.data.licenses,
              cleanFilters: [],
            }),
            this.$store.dispatch("dailyCounters/update", {
              objs: response.data.dailyCounters
                ? response.data.dailyCounters
                : [],
            }),
          ]);
        })
        .then((response) => {
          if (this.$route.params.id) {
            let slugs = this.$route.params.id;
            let slug = slugs.split(",");
            let idWorldEvent = slug[0];
            let idWorldEventInvite = slug[1];
            let status = slug[2];
            if (status) {
              this.updateStatus(idWorldEventInvite, status);
            }

            let el = this.$store.getters["events/get"](idWorldEvent);
            this.showEvent(el);
          }
          this.$Progress.finish();
          this.block = false;
          this.loading = false;
          this.loadEvent = false;
        })
        .catch((error) => console.log(error));
    },
    getMyEvents() {
      this.$http
        .get("events?currentTime=" + this.currentTime)
        .then((response) => {
          {
            return Promise.all([
              this.$store.dispatch("events/update", {
                vlf: this.$vlf("events"),
                objs: response.data.events,
                cleanFilters: [(e) => e.type == 4 || e.type == 8],
                saveFilters: [
                  (e) => e.endTimestamp > this.currentTime - 86400 * 31,
                ],
              }),
              this.$store.dispatch("places/update", {
                vlf: this.$vlf("places"),
                objs: response.data.places,
              }),
              this.$store.dispatch("employments/update", {
                vlf: this.$vlf("employments"),
                objs: response.data.employments,
                cleanFilters: [],
              }),
              this.$store.dispatch("users/update", {
                vlf: this.$vlf("users"),
                objs: response.data.users,
                cleanFilters: [],
              }),
              this.$store.dispatch("invites/update", {
                vlf: this.$vlf("invites"),
                objs: response.data.invites,
                cleanFilters: [],
              }),
              this.$store.dispatch("works/update", {
                vlf: this.$vlf("works"),
                objs: response.data.works,
                cleanFilters: [],
              }),
              this.$store.dispatch("licenses/update", {
                vlf: this.$vlf("licenses"),
                objs: response.data.licenses,
                cleanFilters: [],
              }),
            ]);
          }
        })
        .then((response) => {
          if (this.$route.params.id) {
            let slugs = this.$route.params.id;
            let slug = slugs.split(",");
            let idWorldEvent = slug[0];
            let idWorldEventInvite = slug[1];
            let status = slug[2];
            if (status) {
              this.updateStatus(idWorldEventInvite, status);
            }
            let el = this.$store.getters["events/get"](idWorldEvent);
            this.showEvent(el);
          }
          this.$Progress.finish();
          this.block = false;
          this.loading = false;
          this.loadEvent = false;
        })
        .catch((error) => console.log(error));
    },
    closeChangeWork() {
      this.closeWork = true;
      this.$anm22.setCookie("close", this.closeWork, 31536000);
    },
    showEvent(el) {
      this.selectedEvent = el;
      this.showEventDialog = true;
    },
    selected(event) {
      this.selectedEvent = event;
    },
    showSearch() {
      this.showSearchDialog = true;
    },
    showWorks() {
      this.showWorksDialog = true;
      this.closeWork = true;
      this.$anm22.setCookie("close", this.closeWork, 31536000);
    },
    // newEventClick(date) {
    //   if(date) {
    //     this.tempCreationDate = date;
    //   } else {
    //     this.tempCreationDate = this.$moment();
    //   }
    //   this.showNewEventDialog = true;
    // },
    newEvent(d) {
      const date = d || this.$moment();
      // this.showNewEventDialog = false;
      const start = date.unix();
      const end = date
        .clone()
        .add(1, "hours")
        .unix();
      const el = {
        type: 1,
        creator: this.user.idWorldUser,
        startTimestamp: start,
        endTimestamp: end,
        work: this.workSelected !== "my" ? this.workSelected : 0,
        timezone: "Europe/Rome",
        placeCountry: "it",
        placeCity: "",
        placeName: "",
        placeNumber: "",
        placeState: "",
        placeStreet: "",
        placeZip: "",
      };
      // this.tempCreationDate = null;
      this.showEvent(el);
    },
    removeFilter(index) {
      this.filters.splice(index, 1);
    },
    removeFilterUser(index) {
      this.filterUsers.splice(index, 1);
    },
    resetFilterUsers() {
      this.filterUsers = [];
    },
    resetFilters() {
      this.filters = [];
    },
    openChangeViewDialog() {
      this.showViewDialog = true;
    },
    changeView(id) {
      this.selectedView = id;
      switch (id) {
        case "MonthView":
          this.$anm22.setCookie("com_anm22_calendar_view", "month", 31536000);
          break;
        case "WeeklyView":
          this.$anm22.setCookie("com_anm22_calendar_view", "week", 31536000);
          break;
        case "LastEventView":
          this.$anm22.setCookie("com_anm22_calendar_view", "line", 31536000);
          break;
        case "TicketsView":
          this.$router.push("/tickets");
          break;
      }
      this.showViewDialog = false;
    },
    closeEvent() {
      this.selectedEvent = null;
      this.showEventDialog = false;
    },
    closeSearch() {
      this.showSearchDialog = false;
    },
    closeWorks() {
      this.showWorksDialog = false;
    },
    updateStatus(idWorldEventInvite, status) {
      this.$http
        .post(
          "events/statusinvite",
          {
            idWorldEventInvite: idWorldEventInvite,
            status: status,
          },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          //console.log(response.data);
          this.$store.dispatch("invites/update", {
            vlf: this.$vlf("invites"),
            objs: [response.data.invites],
          });
        })
        .catch((error) => {});
    },
  },
  mounted() {
    this.$anm22.eventBus.$on("event-selected", this.showEvent);
    this.$anm22.eventBus.$on("work-selected", this.selectWork);
    this.$anm22.eventBus.$on("filter-selected", (f) => {
      this.filterUsers = [];
      this.filters.push({ name: f.name, fn: f.fn });
    });
    this.$anm22.eventBus.$on("users-avaiability", (f) => {
      this.filters = [];
      this.filterUsers.push({ id: f.id, name: f.name });
    });
    this.$nextTick(() => {
      this.updateInterval = setInterval(() => {
        if (this.showEventDialog == false) {
          //this.loading=true;
          this.block = true;
          //aggiorno i miei eventi seconda del work selezionato
          this.workSelected == "my" ? this.updateData() : this.updateWorkData();
        }
      }, 120000);
    });
  },
  destroyed() {
    this.$anm22.eventBus.$off("event-selected");
    this.$anm22.eventBus.$off("filter-selected");
    this.$anm22.eventBus.$off("users-avaiability");
    this.$anm22.eventBus.$off("work-selected");
  },

  components: {
    HeadBar,
    MonthView,
    WeeklyView,
    LastEventView,
    EventView,
    FilterView,
    "vue-simple-spinner": Spinner,
    WorkSelect,
    EventDetail,
    TicketsView,
  },
};
</script>

<style lang="scss" scoped>
.resize {
  width: 4% !important;
  height: 8%;
  min-height: 46px;
  overflow: hidden !important;
  border-bottom: none !important;
}
.my-project-icon {
  margin-top: 9px;
  display: inline-block;
  background-color: #00af87;
  color: #fff;
  font-size: 16px;
  padding-top: 5px;
  line-height: 2;
  box-sizing: border-box;
  max-height: 100%;
  height: 40px;
  width: 40px;
  text-align: center;
  overflow: hidden;
  border-radius: 30px;
  vertical-align: middle;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  margin-right: 5px;
}
.contacts-menu {
  background: #fff;
  border-right: 1px solid #eee;
  height: calc(100vh - 60px);
  overflow-x: hidden;
}

// .cont{
//     padding: 21px 0 10px 65px;
//      box-sizing: border-box;
//     position: relative;
//     min-height: 60px;
//     border-radius: 10px;
//     min-width: 70%;
// }

.contacts-menu .item {
  flex-wrap: nowrap;
  align-items: center;
  min-height: 60px;
  border-bottom: 1px solid #eee;
  padding: 10px;
  position: relative;
  &.selectable {
    cursor: pointer;
  }
  &.selectable:hover {
    background: #eee;
  }
  &.selectable.selected {
    background: #eee;
    border-right: 2px solid rgb(10, 171, 244);
  }
}
.contacts-menu .item .image {
  width: 40px;
  height: 40px;
  border: 1px solid #eee;
  border-radius: 20px;
  margin-right: 5px;
}
.r {
  margin-top: 9px;
  height: 40px;
}
.contacts-menu .item .name {
  margin-bottom: 4px;
}
.contacts-menu .item .label {
  border-radius: 4px;
  background-color: #eee;
  font-size: 12px;
  color: #666;
  display: inline-block;
  padding: 2px 4px;
}
.contacts-menu .item .label.customer {
  border-left: 3px solid #88ed7c;
  padding-right: 7px;
}
.contacts-menu .item .label.contact {
  border-left: 3px solid #0aabf4;
  padding-right: 7px;
}
.inlinespinner {
  align-items: center;
}
.contacts-menu .item .label.ticket {
  border-left: 3px solid #cccccc;
  padding-right: 7px;
}

.font {
  font-size: 18px;
}
.contacts-menu .item .label.social {
  border-left: 3px solid #f40a93;
  padding-right: 7px;
}
.anm22-calendar-headmenu-selectWork {
  padding: 30px 8px 8px 68px;
  box-sizing: border-box;
  background-color: #ddd;
  line-height: 1;
  text-align: right;
  width: 100%;
  margin: 0 auto;
  border-bottom: 1px solid #ddd;
}

.filter-button {
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  background-color: #ddd;
  border-radius: 5px;
  padding: 10px;
  margin: 10px 5px;
}
.div-icon-label {
  flex-direction: column;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: center;
  height: 100px;
  width: 100px;
  background-color: #fff;
  border-radius: 4px;
  padding: 10px;
  cursor: pointer;
  &:hover {
    background-color: #efefef;
  }
}
.sub-add-button {
  position: fixed;
  right: 38px;

  &.project {
    bottom: 135px;
  }
  &.event {
    bottom: 90px;
  }
}
.views-list {
  text-align: center;

  .item {
    text-align: center;
    display: inline-block;
    vertical-align: top;
    width: 150px;
    margin: 5px;
    border-radius: 6px;
    cursor: pointer;
    padding: 10px 0 15px 0;

    img {
      display: inline-block;
      height: 60px;
      opacity: 0.6;
    }
    div {
      text-align: center;
      display: block;
      font-size: 16px;
    }
  }
  .item:hover,
  .item.selected {
    background: #eee;
  }
}
</style>
